import { getLotteryModalityByValue } from '../../../constants/lotteryModalidades';

export const MODALITY_DERIVED_FILTER_PARAM = 'totNum';

const FILTERS_USING_TOT_NUM = new Set([
    'qtdLinhas',
    'qtdMaxLinha',
    'qtdQuadEm4Quad',
    'qtdMaxQuadEm4Quad',
]);

export const filterUsesTotNum = (filterName: string) =>
    FILTERS_USING_TOT_NUM.has(filterName);

export const getModalityQtyDisp = (modality: string) =>
    getLotteryModalityByValue(modality)?.qty_disp ?? 60;

export const getEditableFilterParameterKeys = (parameterKeys: string[] = []) =>
    parameterKeys.filter((key) => key !== MODALITY_DERIVED_FILTER_PARAM);

export const enrichFilterParameters = (
    filterName: string,
    parameters: Record<string, unknown> = {},
    modality: string
) => {
    const next = { ...parameters };

    if (filterUsesTotNum(filterName)) {
        next[MODALITY_DERIVED_FILTER_PARAM] = getModalityQtyDisp(modality);
    }

    return next;
};

export const enrichNodeFilters = (
    filters: Array<{ name: string; parameters?: Record<string, unknown> }> = [],
    modality: string
) =>
    filters.map((filter) => ({
        ...filter,
        parameters: enrichFilterParameters(filter.name, filter.parameters ?? {}, modality),
    }));
